export default function ImageUploader({ file, setFile }) {
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };
  
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {file && (
        <div
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #ccc",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
          }}
        >
          <img
            src={URL.createObjectURL(file)}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover" }}
          />
        </div>
      )}
    </div>
  );
}